import { render } from "./zygcfx.vue?vue&type=template&id=65eaf9d6&scoped=true&ts=true"
import script from "./zygcfx.vue?vue&type=script&lang=ts"
export * from "./zygcfx.vue?vue&type=script&lang=ts"

import "./zygcfx.vue?vue&type=style&index=0&id=65eaf9d6&lang=less&scoped=true"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65eaf9d6"]])

export default __exports__